import { Fragment, useEffect, useState } from "react";
import { Menu, Transition } from "@headlessui/react";
import { Bars3Icon } from "@heroicons/react/24/outline";
import { ChevronDownIcon, ShoppingCartIcon } from "@heroicons/react/20/solid";

import { classNames } from "../../shared/utility";

export default function HeaderLayout(props) {
  const { cart, openCart, sidebarOpen, logout, setSidebarOpen } = props;

  const [cartCount, setCartCount] = useState(0);

  useEffect(() => {
    var currCount = 0;
    if (cart) {
      cart.forEach((element) => {
        currCount += parseFloat(element.quantity);
      });
    }
    setCartCount(currCount);
  }, [cart]);

  const userNavigation = [
    {
      name: "My account",
      action: () => {
        window.location = "/my-account";
      },
    },
    { name: "Sign out", action: () => logout() },
  ];

  return (
    <header
      className="hide-for-print layout-header top-0 flex h-16 shrink-0 items-center gap-x-4 px-4 sm:gap-x-6 sm:px-6 lg:px-8"
      role="banner"
    >
      <button
        type="button"
        className="-m-2.5 p-2.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--nav-active-accent)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--nav-bg)] rounded-md transition-colors hover:opacity-80"
        style={{
          color: "var(--nav-text)",
        }}
        onClick={() => setSidebarOpen(!sidebarOpen)}
        aria-expanded={sidebarOpen}
        aria-controls="main-sidebar"
      >
        <span className="sr-only">
          {sidebarOpen ? "Close main sidebar" : "Open main sidebar"}
        </span>
        <Bars3Icon className="h-6 w-6" aria-hidden="true" />
      </button>

      <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
        <div className="relative flex flex-1" aria-hidden="true" />
        <div className="flex items-center gap-x-2 lg:gap-x-2">
          <button
            type="button"
            className="-m-2.5 p-2.5 py-4 px-1 relative border-2 border-transparent rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--nav-active-accent)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--nav-bg)] transition-colors hover:opacity-80"
            style={{ color: "var(--nav-text)" }}
            aria-label={`Cart${cartCount > 0 ? `, ${cartCount} items` : ""}`}
            onClick={openCart}
          >
            <ShoppingCartIcon className="h-6 w-6" aria-hidden="true" />
            {cartCount > 0 && (
              <span className="absolute inset-0 object-right-top -mr-6 pointer-events-none">
                <span
                  className="inline-flex items-center justify-center min-w-[1.25rem] px-1.5 py-0.5 rounded-full text-xs font-semibold leading-4 text-white bg-red-500"
                  aria-hidden="true"
                >
                  {cartCount}
                </span>
              </span>
            )}
          </button>

          <div aria-hidden="true" />

          <Menu as="div" className="relative">
            <Menu.Button
              className="-m-1.5 flex items-center p-1.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--nav-active-accent)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--nav-bg)] rounded-md"
              style={{
                color: "var(--nav-text)",
              }}
            >
              <span className="sr-only">Open my account menu</span>
              <span className="flex lg:items-center">
                <span
                  className="ml-4 text-sm font-semibold leading-6"
                  style={{ color: "var(--nav-text)" }}
                  aria-hidden="true"
                >
                  My account
                </span>
                <ChevronDownIcon
                  className="ml-2 h-5 w-5"
                  style={{ color: "var(--nav-text-secondary)" }}
                  aria-hidden="true"
                />
              </span>
            </Menu.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items
                className="absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded-md py-2 focus:outline-none"
                style={{
                  background: "var(--surface-bg)",
                  border: "var(--surface-border)",
                  boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06)",
                }}
              >
                {userNavigation.map((item) => (
                  <Menu.Item key={item.name}>
                    {({ active }) => (
                      <button
                        className={classNames(
                          "block w-full text-left px-3 py-2 text-sm leading-6 focus:outline-none focus-visible:ring-0",
                          active ? "" : ""
                        )}
                        style={{
                          color: "var(--nav-text)",
                          backgroundColor: active
                            ? "var(--nav-hover-bg)"
                            : "transparent",
                        }}
                        onClick={item.action}
                      >
                        {item.name}
                      </button>
                    )}
                  </Menu.Item>
                ))}
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      </div>
    </header>
  );
}
